import { canUseDOM } from 'exenv';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Slider from 'react-slick';
import AdTagGenerator from './utils/video_module_ads';
import Slug from '../slug/slug';
import Card from '../card/card';

let scriptjs = false;
if (canUseDOM) {
  // eslint-disable-next-line global-require
  scriptjs = require('scriptjs');
}

export default class Video extends Component {
  constructor() {
    super();

    this.state = {
      playingIndex: 0,
      activeTitle: ''
    };

    this.videoCardClick = this.videoCardClick.bind(this);
    this.updateTitle = this.updateTitle.bind(this);
    this.setCaptions = this.setCaptions.bind(this);
    this.setNextVideo = this.setNextVideo.bind(this);
  }

  componentDidMount() {
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({
      settings: {
        arrows: false,
        infinite: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2.3,
              slidesToScroll: 2,
              slide: '.video-slide'
            }
          },
          {
            breakpoint: 100000,
            settings: 'unslick'
          }
        ]
      }
    });

    if (scriptjs) {
      const { playerid, data } = this.props;
      scriptjs(`//content.jwplatform.com/libraries/${playerid}.js`, () => {
        this.player = window.jwplayer('video-module__player');
        this.adTagGenerator = new AdTagGenerator(get(data, 'title'));
        this.initPlayer();
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const updateSettings = !this.state.settings;
    const updatePlayingIndex =
      this.state.playingIndex !== nextState.playingIndex;
    const updateActiveTitle = this.state.activeTitle !== nextState.activeTitle;

    return updateSettings || updatePlayingIndex || updateActiveTitle;
  }

  componentWillUnmount() {
    if (get(this, 'player.remove')) this.player.remove();
  }

  getVideoImage(image) {
    if (!image) return '';
    return `//fast-company-res.cloudinary.com/image/fetch/w_280,q_auto,f_auto,fl_lossy/https:${image}`;
  }

  getVideoList() {
    const { stories } = this.props;

    return stories.map((video, index) => ({
      id: video.mediaid,
      title: video.title,
      link: video.link,
      featured_image: {
        source: this.getVideoImage(get(video, 'image'))
      },
      isVideo: true,
      isVideoActive: this.state.playingIndex === index,
      index
    }));
  }

  setCaptions() {
    const caption = this.player.getMute() ? 1 : 0;
    return this.player.setCurrentCaptions(caption);
  }

  setNextVideo() {
    const playingIndex = this.state.playingIndex + 1;
    this.setState({ playingIndex });
  }

  updateTitle() {
    const video = this.player.getPlaylistItem();
    this.setState({ activeTitle: video.title });
  }

  initPlayer() {
    const { data, playerid } = this.props;
    const options = {
      playlist: `//content.jwplatform.com/feeds/${data.feedid}.json`,
      autostart: 'viewable'
    };

    if (playerid !== '76APbejE') {
      options.advertising = {
        client: 'googima',
        tag: this.adTagGenerator.adTag,
        vpaidcontrols: true
      };
    }

    this.player.setup(options);

    this.player.on('ready', () => {
      this.player.setMute(true);
      this.player.on('playlistItem', this.updateTitle);
      this.player.on('play', this.setCaptions);
      this.player.on('mute', this.setCaptions);
      this.player.on('complete', this.setNextVideo);
    });
  }

  videoCardClick(event, index) {
    this.setState({ playingIndex: index });
    this.player.playlistItem(index);
  }

  renderSlides() {
    const { settings } = this.state;
    if (settings) {
      const stories = this.getVideoList();
      return (
        <div className="video-module-playlist">
          <Slider {...settings}>
            {stories.map(item =>
              <div className="video-slide" key={item.id}>
                <Card
                  className="video-module-playlist"
                  metadata={item}
                  cardEvent={this.videoCardClick}
                  columnCard
                />
              </div>
            )}
          </Slider>
        </div>
      );
    }

    return null;
  }

  render() {
    const { slugName, isPost } = this.props;

    return (
      <section className={`video-row ${isPost ? 'video-row--post' : ''}`}>
        <Slug linkTo="//fastcompany.com/videos" slugName={slugName} />
        <div className="video-module">
          <div className="video-module__player-container">
            <div id="video-module__player" />
          </div>
          <div className="video-module__title">{this.state.activeTitle}</div>
        </div>
        {this.renderSlides()}
      </section>
    );
  }
}

Video.defaultProps = {
  stories: [],
  data: {},
  slugName: 'Video',
  isPost: false
};

Video.propTypes = {
  stories: PropTypes.arrayOf(PropTypes.shape({})),
  data: PropTypes.shape({}),
  playerid: PropTypes.string.isRequired,
  slugName: PropTypes.string,
  isPost: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/views/components/video_module/video_module.js